import {StaffAccessLevels} from "@/enums/StaffAccessLevels";

export default {
  computed: {
    user() {
      return this.$store.state.authModule.user;
    },
    isOrgAdmin() {
      return this.user.accessLevel === StaffAccessLevels.OrgAdmin;
    },
    isFacilityAdmin() {
      return this.user.accessLevel === StaffAccessLevels.FacilityAdmin;
    },
    isAdmins() {
      return this.isOrgAdmin || this.isFacilityAdmin;
    }
  }
};